function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { i18n, MetadataConstants, MetadataSelectors, FormHelper } from 'invision-core';
import { NOTIFICATION_TIME_LENGTH } from '../../../../customercare.constants';
import { createConvergentBillerPromiseToPaySchedule } from '../../../../reducers/actions/customer.convergent.biller.actions';
import { PeriodTypeOptionsSelector, PromiseToPayCreationErrorSelector } from '../../../../reducers/selectors/customer.convergent.biller.selectors';
import CustomerCareLocaleKeys from '../../../../locales/keys';
import { fetchCodeTypesThunk } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { CurrentBusinessUnitTimeZoneOffsetSelector } from 'invision-core/src/components/session/businessunit.selectors';
import moment from 'moment';
var CreatePromiseToPayPopupController = /*#__PURE__*/function () {
  function CreatePromiseToPayPopupController($ngRedux, $timeout, uiNotificationService) {
    var _this = this;
    _classCallCheck(this, CreatePromiseToPayPopupController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      uiNotificationService: uiNotificationService,
      onChangeNumberInstallments: function onChangeNumberInstallments() {
        var installments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.installmentsMin;
        _this.promiseToPayDetails.Installments = installments;
        _this.estimatedInstallmentAmount = _this.promiseToPayDetails.Installments ? _this.treatmentBalance / _this.promiseToPayDetails.Installments : null;
      }
    });
  }
  return _createClass(CreatePromiseToPayPopupController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentBUTimeZoneOffset: CurrentBusinessUnitTimeZoneOffsetSelector(store),
          paymentPeriodsLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.PeriodType, store),
          paymentPeriodOptions: PeriodTypeOptionsSelector(store),
          lastAttemptError: PromiseToPayCreationErrorSelector(store)
        };
      };
      var controllerActions = {
        fetchCodeTypesThunk: fetchCodeTypesThunk,
        createConvergentBillerPromiseToPaySchedule: createConvergentBillerPromiseToPaySchedule
      };
      this.CustomerCareLocaleKeys = CustomerCareLocaleKeys;
      this.promiseToPayCreationCallback = this.onPromiseToPayCreation() || angular.noop;
      this.todaysDate = new Date();
      this._resetForm();
      this.showForm = false;
      this.installmentsMin = 1;
      this.installmentsMax = Number.MAX_VALUE; // The stepper component requires a max...
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
      if (!this.state.paymentPeriodsLoaded) {
        this.actions.fetchCodeTypesThunk(CODES.PeriodType).then(function () {
          _this2.paymentPeriodOptions = _this2.state.paymentPeriodOptions.asMutable({
            deep: true
          });
        });
      }
      this.paymentPeriodOptions = this.state.paymentPeriodOptions.asMutable({
        deep: true
      });
      var onRegisterApi = this.config.onRegisterApi;
      this.config.onRegisterApi = function (_ref) {
        var api = _ref.api;
        _this2.popupApi = Object.assign({}, api, {
          open: function open() {
            _this2._resetForm();
            _this2.showForm = true;
            _this2.$timeout(function () {
              api.open();
            });
          }
        });
        onRegisterApi && onRegisterApi({
          api: _this2.popupApi
        });
      };
      this.fieldErrorLookup = {
        PeriodType: {
          required: i18n.translate(CustomerCareLocaleKeys.TREATMENT_DETAILS.CREATE_PROMISE_TO_PAY.ERRORS.PERIOD_REQUIRED)
        },
        InstallmentStartDate: {
          required: i18n.translate(CustomerCareLocaleKeys.TREATMENT_DETAILS.CREATE_PROMISE_TO_PAY.ERRORS.START_DATE_REQUIRED),
          'invalidDate': i18n.translate(CustomerCareLocaleKeys.TREATMENT_DETAILS.CREATE_PROMISE_TO_PAY.ERRORS.START_DATE_INVALID),
          'minDate': i18n.translate(CustomerCareLocaleKeys.TREATMENT_DETAILS.CREATE_PROMISE_TO_PAY.ERRORS.START_DATE_IN_PAST)
        }
      };
    }
  }, {
    key: "shouldShowErrorForField",
    value: function shouldShowErrorForField(fieldName) {
      return (this.formApi[fieldName].$touched || this.formApi.$submitted) && this.formApi[fieldName].$invalid;
    }
  }, {
    key: "closePopup",
    value: function closePopup() {
      this.popupApi.close();
      this.showForm = false;
    }
  }, {
    key: "handleSubmitForm",
    value: function handleSubmitForm() {
      var _this3 = this;
      if (!this._checkForErrors()) {
        this.promiseToPayDetails.InstallmentStartDate = this.addTimeInfoForTodaysDate(this.promiseToPayDetails.InstallmentStartDate);
        this.actions.createConvergentBillerPromiseToPaySchedule(this.customerId, this.promiseToPayDetails).then(function () {
          _this3.uiNotificationService.success(i18n.translate(CustomerCareLocaleKeys.TREATMENT_DETAILS.CREATE_PROMISE_TO_PAY.SUCCESS), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
          _this3.promiseToPayCreationCallback();
          _this3.closePopup();
        }, function () {
          if (_this3.state.lastAttemptError && _this3.state.lastAttemptError.message) {
            _this3.serviceError = _this3.state.lastAttemptError.message;
          } else {
            _this3.serviceError = i18n.translate(CustomerCareLocaleKeys.TREATMENT_DETAILS.CREATE_PROMISE_TO_PAY.ERRORS.FORM_API_SUBMISSION_FAILED_UNKNOWN_REASON);
          }
        });
      }
    }
  }, {
    key: "_checkForErrors",
    value: function _checkForErrors() {
      this.serviceError = null;
      this.formErrors = FormHelper.formHasErrors(this.formApi.$error, this.fieldErrorLookup);
      return this.formErrors.length > 0;
    }
  }, {
    key: "_resetForm",
    value: function _resetForm() {
      this.promiseToPayDetails = {
        Installments: this.installmentsMin,
        InstallmentStartDate: this.todaysDate,
        PeriodType: null,
        PromiseTotalAmount: this.treatmentBalance
      };
      this.onChangeNumberInstallments();
      this.serviceError = null;
      this.formErrors = [];
    }
  }, {
    key: "addTimeInfoForTodaysDate",
    value: function addTimeInfoForTodaysDate(installmentStartDate) {
      // If the Installment Start Date is today, add the time info from the moment, else leave the installment start date to be the start time in the local timezone midnight.
      var currentDate = new Date();
      if (installmentStartDate.getFullYear() === currentDate.getFullYear() && installmentStartDate.getMonth() === currentDate.getMonth() && installmentStartDate.getDate() === currentDate.getDate()) {
        return currentDate;
      } else {
        var browserTimeZoneOffsetMinutes = new Date().getTimezoneOffset();
        var buTimezoneOffsetMinutes = moment.duration(this.state.currentBUTimeZoneOffset).asMinutes();
        return moment(installmentStartDate).utc().utcOffset(browserTimeZoneOffsetMinutes + Number(buTimezoneOffsetMinutes), true).toISOString();
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./create.promise.to.pay.popup.html'),
  bindings: {
    config: '<',
    customerId: '@',
    onPromiseToPayCreation: '&',
    treatmentBalance: '<',
    treatmentCurrency: '@'
  },
  controllerAs: 'CreatePromiseToPayPopup',
  controller: CreatePromiseToPayPopupController
};